import Admin from './Admin.json';
import Analyst from './Analyst.json';
import Dashboard from './Dashboard.json';
import Operator from './Operator.json';

type Permission = Record<string, Record<string, boolean>>;

type PermissionsMap = {
  Admin: Permission;
  Analyst: Permission;
  Dashboard: Permission;
  Operator: Permission;
};

export const permissions: PermissionsMap = {
  Admin,
  Analyst,
  Dashboard,
  Operator,
};

/**
 * getRoles
 *
 * Returns the roles.
 */
export function getRoles(): (keyof PermissionsMap)[] {
  return Object.keys(permissions) as (keyof PermissionsMap)[];
}

/**
 * getRolesWithAttribute
 *
 * Returns the roles that have the specified attribute.
 */
export function getRolesWithAttribute(
  resource: string = '',
  action: string = '',
  value: any = null
): (keyof PermissionsMap)[] {
  const theRoles: (keyof PermissionsMap)[] = [];
  const roles = getRoles();

  roles.forEach((role) => {
    if (permissions[role]?.[resource]?.[action] === value) {
      theRoles.push(role);
    }
  });

  return theRoles;
}
